"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var qs_1 = __importDefault(require("qs"));

var react_1 = require("react");

var listeners = [];

exports.html5HistoryAdapter = function () {
  return {
    listen: function listen(listener) {
      var listenerIndex = listeners.push(listener) - 1;
      return function () {
        delete listeners[listenerIndex];
      };
    },
    location: window.location,
    push: function push(_a) {
      var search = _a.search;
      window.history.pushState(window.history.state, document.title, search);
      listeners.forEach(function (listener) {
        return listener();
      });
    },
    replace: function replace(_a) {
      var search = _a.search;
      window.history.replaceState(window.history.state, document.title, search);
      listeners.forEach(function (listener) {
        return listener();
      });
    }
  };
};

var qsSerialisation = function qsSerialisation() {
  return {
    parse: function parse(queryString) {
      return qs_1.default.parse(queryString, {
        ignoreQueryPrefix: true
      });
    },
    stringify: function stringify(state) {
      return qs_1.default.stringify(state, {
        addQueryPrefix: true
      });
    }
  };
};

var parseConfig = function parseConfig(config) {
  if (config === void 0) {
    config = {};
  }

  return {
    history: config.history || exports.html5HistoryAdapter(),
    // TODO switch to using https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/entries to avoid the dependency on qs
    serialisation: config.serialisation || qsSerialisation()
  };
};

function useUrlState(initialState, config) {
  var _a = react_1.useMemo(function () {
    return parseConfig(config);
  }, [config]),
      history = _a.history,
      serialisation = _a.serialisation;

  var _b = react_1.useState(__assign({}, initialState, serialisation.parse(history.location.search))),
      currentState = _b[0],
      setSearch = _b[1];

  react_1.useEffect(function () {
    history.replace(__assign({}, history.location, {
      search: serialisation.stringify(currentState)
    }));
    return history.listen(function onLocationChange() {
      setSearch(serialisation.parse(history.location.search));
    });
  }, [history]);

  function setUrlState(setStateAction, historyAction) {
    setSearch(function (previousState) {
      var newState = typeof setStateAction === 'function' ? setStateAction(previousState) : __assign({}, previousState, setStateAction);

      var nextLocation = __assign({}, history.location, {
        search: serialisation.stringify(newState)
      });

      historyAction === 'replace' ? history.replace(nextLocation) : history.push(nextLocation);
      return newState;
    });
  }

  return [currentState, setUrlState];
}

exports.useUrlState = useUrlState;

exports.UrlState = function (props) {
  var _a = useUrlState(props.initialState, props.config),
      urlState = _a[0],
      setUrlState = _a[1];

  return props.render({
    setUrlState: setUrlState,
    urlState: urlState
  });
};

exports.withUrlState = function (getInitialState, config) {
  if (config === void 0) {
    config = {};
  }

  return function (WrappedComponent) {
    return function (props) {
      var _a = useUrlState(getInitialState(props), config),
          urlState = _a[0],
          setUrlState = _a[1];

      return react_1.createElement(WrappedComponent, __assign({}, props, {
        urlState: urlState,
        setUrlState: setUrlState
      }));
    };
  };
};